import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HEALTH_LABEL = {
    on_track: "on track",
    at_risk: "at risk",
    behind: "behind",
};
// Maps a health value to the bar/pill modifier class (styled in styles.css:
// .okr-bar.ok/.warn/.danger and .okr-pill.ok/.warn/.danger).
export function healthClass(h) {
    return h === "on_track" ? "ok" : h === "at_risk" ? "warn" : "danger";
}
export const SOURCE_LABEL = {
    manual: "Manual",
    rollup_goals: "Rolls up from goals",
    auto_projects: "Auto · completed projects",
    auto_time: "Auto · logged time",
    auto_crm: "Auto · CRM signings",
    auto_crm_pipeline: "Auto · CRM pipeline value",
};
export function HealthPill({ health }) {
    return (_jsx("span", { className: `okr-pill ${healthClass(health)}`, children: HEALTH_LABEL[health] }));
}
// A progress bar. `targetPct` optionally draws a pace marker (where the
// team "should" be by now) so a bar reads against time, not just absolute.
export function ProgressBar({ pct, health, targetPct, }) {
    const cls = health ? healthClass(health) : "";
    return (_jsxs("div", { className: `okr-bar ${cls}`, children: [_jsx("span", { style: { width: `${Math.min(100, Math.max(0, pct))}%` } }), targetPct != null && targetPct > 0 && targetPct < 100 && (_jsx("i", { className: "okr-bar-target", style: { left: `${targetPct}%` } }))] }));
}
